import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=27cada76&scoped=true"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=27cada76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cada76",
  null
  
)

export default component.exports